(() => {
  const initialize = root => {
    const form = root.querySelector('form');
    const input = form?.querySelector('input[name="q"]');
    if (!input) return;
    const results = document.createElement('div');
    results.className = 'rn-predictive-results';
    results.id = `${input.id}-results`;
    const status = document.createElement('p');
    status.className = 'rn-search-status';
    status.setAttribute('role', 'status');
    const empty = form.querySelector('.rn-search-empty');
    form.insertBefore(status, empty); form.insertBefore(results, empty);
    status.textContent = 'Start typing to discover Reneora.';
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('aria-controls', results.id);
    let timer, controller, serial = 0;
    const safeURL = (value, image = false) => {
      try { const url = new URL(value, location.origin); return (image ? url.protocol === 'https:' : url.origin === location.origin) ? url.href : ''; } catch { return ''; }
    };
    const run = async () => {
      clearTimeout(timer); controller?.abort(); const current = ++serial;
      results.replaceChildren(); status.textContent = '';
      const query = input.value.trim();
      if (empty) empty.hidden = !!query;
      if (!query) { status.textContent = 'Start typing to discover Reneora.'; return; }
      timer = setTimeout(async () => {
        controller = new AbortController();
        status.textContent = 'Searching…';
        try {
          const q = /^lips$/i.test(query) ? 'lip' : query;
          const params = new URLSearchParams({q, 'resources[type]':'product', 'resources[limit]':'10', 'resources[options][fields]':'title,product_type,variants.title'});
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}search/suggest.json?${params}`, {signal:controller.signal});
          if (!response.ok) throw new Error('Search unavailable');
          const data = await response.json();
          if (current !== serial) return;
          let products = data.resources?.results?.products || [];
          if (/^lips?$/i.test(query)) products = products.filter(product => /lip/i.test(`${product.title} ${product.type || ''}`));
          if (/^moisturi[sz]ers?$/i.test(query)) products = products.filter(product => /moisturi[sz]/i.test(`${product.title} ${product.type || ''}`));
          for (const product of products) {
            const href = safeURL(product.url); if (!href) continue;
            const card = document.createElement('a'); card.href = href; card.className = 'rn-predictive-card';
            const source = safeURL(product.image || product.featured_image?.url, true);
            if (source) { const image = document.createElement('img'); image.src = source; image.alt = ''; image.width = 90; image.height = 110; card.append(image); }
            const text = document.createElement('span');
            const category = document.createElement('small');
            const name = product.title.toLowerCase();
            category.textContent = product.type || (/lip/.test(name) ? 'Lips' : /foundation|conceal/.test(name) ? 'Complexion' : /cheek|blush|bronzer/.test(name) ? 'Cheeks' : /eye|mascara|brow/.test(name) ? 'Eyes' : 'Skincare');
            const title = document.createElement('strong'); title.textContent = product.title;
            const label = document.createElement('span'); label.textContent = 'Discover product →';
            text.append(category,title,label); card.append(text); results.append(card);
          }
          status.textContent = products.length ? `${products.length} suggestions` : 'No matching products. Try another name.';
          const all = document.createElement('a'); const url = new URL(form.action); url.searchParams.set('q',q); url.searchParams.set('type','product');
          all.href = url.href; all.className = 'rn-search-all'; all.textContent = 'View all results →'; results.append(all);
        } catch(error) { if (error.name !== 'AbortError' && current === serial) status.textContent = 'Press Search to view the results.'; }
      }, 180);
    };
    const close = () => { root.open = false; root.querySelector('summary').focus(); };
    const closeButton = root.querySelector('.rn-search-close');
    const toggle = () => { if (root.open) { document.querySelectorAll('.reneora-header__mobile[open]').forEach(menu => menu.open = false); input.focus(); } else {clearTimeout(timer); controller?.abort(); serial++;} };
    const escape = event => { if (event.key === 'Escape' && root.open) close(); };
    closeButton?.addEventListener('click',close); root.addEventListener('keydown',escape);
    const keydown = event => { if (event.key === 'ArrowDown' && event.target === input) { const first = results.querySelector('a'); if (first) {event.preventDefault();first.focus();} } };
    input.addEventListener('input',run); root.addEventListener('toggle',toggle); input.addEventListener('keydown',keydown);
    return () => {clearTimeout(timer);controller?.abort();serial++;input.removeEventListener('input',run);root.removeEventListener('toggle',toggle);input.removeEventListener('keydown',keydown);closeButton?.removeEventListener('click',close);root.removeEventListener('keydown',escape);status.remove();results.remove();};
  };
  window.ReneoraTheme?.register('predictive-search','.reneora-header__search',initialize);
})();
